import { useInViewWithPrerender } from '../../hooks/useInViewWithPrerender';
import { useBrowserMinMediaQuery } from '../atoms/ResponsiveBreakpoints';
import styles from './ListBlock.module.scss';
import { getBannerSize } from './ListBlock.utils';

export const useListBlockLazyLoading = (lazyLoad: boolean = true) => {
    const inView = useInViewWithPrerender({
        triggerOnce: true,
        threshold: 0,
        rootMargin: '50px',
        initialInView: !lazyLoad,
    });

    return inView;
};

export const useGridBannerSize = (cellsInRow: number) => {
    const isMoreThan900px = useBrowserMinMediaQuery(900);
    const bannerCellSize = getBannerSize(cellsInRow);

    if (cellsInRow === 3 && !isMoreThan900px) {
        return styles[`BannerCell${3}of${cellsInRow}`];
    }

    return styles[`BannerCell${bannerCellSize}of${cellsInRow}`];
};
